<template>
  <div class="cleanup-confirm-dialog-box">
    <el-dialog
      :title="$t('wrh-dashboard.cleanup-confirm-dialog-box.title')"
      @close="onClose"
      :show-close="false"
      visible>

      <div class="mx-24 my-24 el-text el-text--size-xs">
        <div style="margin-top: 13px; margin-bottom: -4px;">
          {{ $t('wrh-dashboard.cleanup-confirm-dialog-box.message') }}
        </div>
      </div>

      <template #footer>
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary">
          {{ $t('wrh-dashboard.form.button.cancel') }}
        </el-button>

        <el-button
          native-type="button"
          type="danger"
          @click="onSubmitCleanupConfirm">
          {{ $t('wrh-dashboard.form.button.delete') }}
        </el-button>

      </template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'CleanupConfirmDialogBox',
  methods: {
    onSubmitCleanupConfirm() {
      this.$emit('submitCleanupConfirm');
    },
    onClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
